// extracted by mini-css-extract-plugin
export default {"payModalWrap":"payModal_payModalWrap__q+q1e","payModalWrap2":"payModal_payModalWrap2__zQLtm","payModalWrap_P":"payModal_payModalWrap_P__5e0dM"};